import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_add_role",
  ref: "RolFormModalRef",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-750px bg-gray" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "fs-2 fw-bold" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "isax-close-circle text-white fs-2x" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "modal-body scroll-y" }
const _hoisted_9 = {
  class: "d-flex flex-column scroll-y me-n7 pe-7",
  id: "kt_modal_add_role_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_add_role_header",
  "data-kt-scroll-wrappers": "#kt_modal_add_role_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_10 = { class: "fv-row mb-10" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "fs-base fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Tipo de rol")
], -1)
const _hoisted_12 = {
  key: 0,
  class: "form-check form-check-custom form-check-solid mb-5"
}
const _hoisted_13 = ["id", "value", "selected"]
const _hoisted_14 = {
  key: 1,
  class: "input-group mb-5"
}
const _hoisted_15 = { class: "input-group-text" }
const _hoisted_16 = { class: "fv-row mb-10" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "fs-base fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Nombre del rol")
], -1)
const _hoisted_18 = { class: "input-group mb-5" }
const _hoisted_19 = { class: "input-group-text" }
const _hoisted_20 = { class: "fv-plugins-message-container" }
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = { class: "fv-row mb-10" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "fs-base fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Descripción")
], -1)
const _hoisted_24 = { class: "input-group" }
const _hoisted_25 = { class: "input-group-text" }
const _hoisted_26 = { class: "d-flex flex-row justify-content-between align-items-center" }
const _hoisted_27 = { class: "fs-5 fw-bold" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "separator border-2 my-5" }, null, -1)
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "form-check form-check-sm form-check-custom form-check-solid fs-sm me-5 me-lg-20" }
const _hoisted_31 = ["id", "value"]
const _hoisted_32 = { class: "form-check-label fs-sm" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "separator border-1 my-5" }, null, -1)
const _hoisted_34 = { class: "fv-plugins-message-container" }
const _hoisted_35 = { class: "fv-help-block" }
const _hoisted_36 = { class: "text-center pt-15" }
const _hoisted_37 = ["data-kt-indicator"]
const _hoisted_38 = {
  key: 0,
  class: "indicator-label fs-base"
}
const _hoisted_39 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_40 = {
  key: 1,
  class: "indicator-progress fs-base"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.typeForm == "new" ? "Nuevo rol" : "Editar rol"), 1),
          _createElementVNode("div", {
            class: "btn btn-icon btn-sm btn-active-icon-primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
          }, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Form, {
            onInvalidSubmit: _ctx.onInvalidSubmit,
            "validation-schema": _ctx.validateRole,
            model: _ctx.formRoleData,
            onSubmit: _ctx.submit
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  (_ctx.typeForm == 'new')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.catRoleTypes, (roleType, index) => {
                          return (_openBlock(), _createElementBlock("label", {
                            class: "form-check-label fs-base me-3",
                            key: index
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input h-18px w-18px me-1",
                              type: "radio",
                              name: "role_type",
                              id: roleType.id_role_condition,
                              value: roleType.id_role_condition,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formRoleData.id_role_condition) = $event)),
                              selected: 
                        roleType.id_role_condition ===
                        _ctx.formRoleData.id_role_condition
                          ? 'selected'
                          : ''
                      
                            }, null, 8, _hoisted_13), [
                              [_vModelRadio, _ctx.formRoleData.id_role_condition]
                            ]),
                            _createTextVNode(" " + _toDisplayString(roleType.name_role_condition), 1)
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("span", _hoisted_15, [
                          _createVNode(_component_inline_svg, { src: "media/icons/iconsax/crown-1.svg" })
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          class: "form-control text-gray-700",
                          type: "text",
                          readonly: "",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formRoleData.name_role_condition) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.formRoleData.name_role_condition]
                        ])
                      ]))
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("span", _hoisted_19, [
                      _createVNode(_component_inline_svg, { src: "media/icons/iconsax/crown-1.svg" })
                    ]),
                    _createVNode(_component_Field, {
                      class: "form-control fs-base",
                      type: "text",
                      placeholder: "Escribe el nombre para el rol",
                      modelValue: _ctx.formRoleData.name,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formRoleData.name) = $event)),
                      name: "role_name"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_ErrorMessage, { name: "role_name" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("span", _hoisted_25, [
                      _createVNode(_component_inline_svg, { src: "media/icons/iconsax/edit-2.svg" })
                    ]),
                    _withDirectives(_createElementVNode("textarea", {
                      class: "form-control fs-base",
                      placeholder: "Describe una breve descripción del rol",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formRoleData.description) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.formRoleData.description]
                    ])
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.catModules, (modulo) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: modulo.idModule
                  }, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, _toDisplayString(modulo.nameModule), 1)
                    ]),
                    _hoisted_28,
                    _createElementVNode("div", _hoisted_29, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modulo.list_access, (access) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "col-sm-6 col-md-4 mb-5",
                          key: access.idAccess
                        }, [
                          _createElementVNode("label", _hoisted_30, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              type: "checkbox",
                              id: access.idAccess,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formRoleData.list_access) = $event)),
                              name: "roles_access",
                              value: { id_access: access.idAccess }
                            }, null, 8, _hoisted_31), [
                              [_vModelCheckbox, _ctx.formRoleData.list_access]
                            ]),
                            _createElementVNode("span", _hoisted_32, _toDisplayString(access.nameAccess), 1)
                          ])
                        ]))
                      }), 128))
                    ]),
                    _hoisted_33
                  ]))
                }), 128)),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createVNode(_component_ErrorMessage, { name: "roles_access" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-secondary me-3 fs-base",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.closeModal()))
                }, " Descartar "),
                _createElementVNode("button", {
                  "data-kt-indicator": _ctx.loading ? 'on' : null,
                  class: "btn btn-lg btn-primary",
                  type: "submit"
                }, [
                  (!_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_38, [
                        _createTextVNode(_toDisplayString(_ctx.typeForm == "new" ? "Guardar" : "Actualizar") + " ", 1),
                        _createElementVNode("span", _hoisted_39, [
                          _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_40, [
                        _createTextVNode(" Guardando... "),
                        _hoisted_41
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_37)
              ])
            ]),
            _: 1
          }, 8, ["onInvalidSubmit", "validation-schema", "model", "onSubmit"])
        ])
      ])
    ])
  ], 512))
}